import { FC } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Chip, ChipProps } from '@mui/material';

interface SuggestionChipProps extends Omit<ChipProps, 'onClick' | 'label'> {
    onClick: (label: string) => void;
    label: string;
}

const SuggestionChip: FC<SuggestionChipProps> = ({
    onClick: handleClick,
    label,
    ...rest
}: SuggestionChipProps) => (
    <Chip
        icon={<AddIcon />}
        key={label}
        tabIndex={-1}
        label={label}
        sx={{
            mr: 0.5,
            mb: 0.5,
            ...(rest.sx || {}),
        }}
        onClick={() => handleClick(label)}
        {...rest}
    />
);

export default SuggestionChip;
